// extracted by css-extract-rspack-plugin
export default {"tasksListItem":"TasksList_tasksListItem__l9ajV"};